import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d0244112"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = {
  key: 0,
  class: "modal"
}
const _hoisted_6 = { class: "contenedor" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Filtros", -1))
const _hoisted_8 = { class: "contenido" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = { class: "facturas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ListadoComponent = _resolveComponent("ListadoComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      ($data.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (this.showModalMethod())),
                  class: "contenido"
                }, [
                  _createVNode(_component_Filters, {
                    filterFacturas: $options.filterFacturas,
                    search: $options.search,
                    filteredFacturas: _ctx.filteredFacturas
                  }, null, 8, ["filterFacturas", "search", "filteredFacturas"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h4", null, [
            _createTextVNode(" Facturas " + _toDisplayString(this.$store.state.user.numProcess) + " (" + _toDisplayString(this.$store.state.user.descProcess) + ") ", 1),
            _createElementVNode("i", {
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalMethod())),
              class: "fas fa-filter",
              _mstvisible: "2"
            })
          ]),
          _withDirectives(_createVNode(_component_ListadoComponent, { facturas: $data.facturas }, null, 8, ["facturas"]), [
            [_vShow, !$data.cargando]
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}